import http from '@/support/plugin/axios'

export const 

//Obter lista de resgate
getAvailableOffersByCompanyIdAndCurrentContactId = (companyId) => http.get(`companies/${companyId}/contacts/current/offers/available`),

//Obter Informações do ranking
getRankingByCompanyIdAndCurrentContactId = (companyId) => http.get(`companies/${companyId}/contacts/current/loyalty/ranking`),

//Obter pontos de expiração por id da empresa e id de contato atual
getExpiringPointsByCompanyIdAndCurrentContactId = (companyId) => http.get(`companies/${companyId}/contacts/current/points/expiring`),


getCompanyLoyaltyByCompanyId = (id) =>  http.get(`companies/${id}/loyalty`)